import { commonErrorMessages, FileDownloaded } from 'azshared';
import React, { useMemo } from 'react';
import { Loader, LoaderSize } from '../../../../../components/loader/loader';
import { defineMessages, useIntl } from 'react-intl';
import Icon from '@mdi/react';
import { mdiFilePdfBox } from '@mdi/js';
import { AppButton, AppButtonVariant } from '../../../../../components/buttons/app-button';
import { downloadFile } from '../../../../../utils/utils';

export interface PdfViewProps {
  pdf?: FileDownloaded;
  url?: string;
  pdfLoading: boolean;
  error?: boolean;
}

const localMessages = defineMessages({
  pdfViewerNotSupportedTitle: {
    id: 'features.wallet.pdfViewerNotSupportedTitle',
    defaultMessage: 'Anteprima PDF'
  },
  pdfViewerNotSupportedDesc: {
    id: 'features.wallet.pdfViewerNotSupportedDesc',
    defaultMessage: 'Il tuo browser o dispositivo non supporta la visualizzazione del PDF direttamente nella pagina'
  },
  downloadPdfButton: {
    id: 'features.wallet.downloadPdfButton',
    defaultMessage: 'Visualizza'
  }
});

export const PdfView = (props: PdfViewProps) => {

  const { pdf, url, pdfLoading, error } = props;
  const { formatMessage } = useIntl();

  const urlPdf = useMemo(() => pdf && URL.createObjectURL(pdf.blob), [pdf]);

  const isInlinePdfSupported = useMemo(() => {
    if (typeof window === 'undefined') return true;
    const isIOS = typeof navigator !== 'undefined' &&
      (/iPad|iPhone|iPod/.test(navigator.userAgent) ||
       (/Macintosh/.test(navigator.userAgent) && navigator.maxTouchPoints > 1));
    if (isIOS) return true;
    const hasPdfViewer = typeof navigator !== 'undefined' && navigator.pdfViewerEnabled;
    return !!hasPdfViewer;
  }, []);

  const handleOpenPdf = () => {
    if (pdf) {
      downloadFile(pdf.name, pdf.blob);
    } else if (url) {
      window.open(url, '_blank');
    }
  };
  
  return <div className='pdf-view'>
    {
      pdfLoading && <Loader className={'pdf-view-loader'} loadersize={LoaderSize.XL} />
    }
    {!pdfLoading && error && (
        <div className='pdf-view-error'>
          <div className='pdf-view-error-icon'>⚠️</div>
          <h3 className='pdf-view-error-title'>
            {formatMessage(commonErrorMessages.errorTitlePopup)}
          </h3>
          <p className='pdf-view-error-description'>
            {formatMessage(commonErrorMessages.errorSchedaProdottoNotAvailable)}
          </p>
        </div>
    )}
    {
      !pdfLoading && !error && !isInlinePdfSupported && (urlPdf || url) && (
        <div className='pdf-view-fallback'>
          <div className='pdf-view-fallback-icon'>
            <Icon path={mdiFilePdfBox} size={3} />
          </div>
          <h3 className='pdf-view-fallback-title'>
            {formatMessage(localMessages.pdfViewerNotSupportedTitle)}
          </h3>
          <p className='pdf-view-fallback-description'>
            {formatMessage(localMessages.pdfViewerNotSupportedDesc)}
          </p>
          <AppButton
            variant={AppButtonVariant.Primary}
            label={formatMessage(localMessages.downloadPdfButton)}
            onClick={handleOpenPdf}
          />
        </div>
      )
    }
    {
      !pdfLoading && !error && isInlinePdfSupported && urlPdf &&  <iframe src={urlPdf}></iframe>
    }
    {
      !pdfLoading && !error && isInlinePdfSupported && !urlPdf && url && <iframe src={url}></iframe>
    }
  </div>;
};